import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { GoBack } from '@/_shared/components/GoBack';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Roles } from '@/_shared/constants/roles';
import { ContentType } from '@/swagger/constants/contents-orchestrator-enums';
import { Sections } from '../components';

export const SpecificContentsScreen = () => {
  const t = useTranslations('trainingHardSkills');
  const { setLayout } = useContext(LayoutContext);
  const { contentType } = useParams<{ contentType: `${ContentType}` }>();

  useEffect(() => {
    setLayout({ title: 'trainingHardSkills' });
  }, [setLayout, t]);

  return (
    <>
      <GoBack />
      <ClaimsComponent roles={[Roles.Employee, Roles.Manager]}>
        <Box mb='l'>
          <Sections.ContentsInProgress
            filterType={contentType?.toLocaleUpperCase() as ContentType}
          />
        </Box>
      </ClaimsComponent>
      <Sections.PaginatedContents filterType={contentType?.toLocaleUpperCase() as ContentType} />
    </>
  );
};
